// extracted by mini-css-extract-plugin
export default {"header-content":"styles_header-content__bZbpf","logo":"styles_logo__jsf80","header-page-buttons":"styles_header-page-buttons__+cQ89"};